import {formatCof} from '../global.js';

$(function () {
    setInterval(cofs_update, 5000)
})

// cofs autoupdater
export const cofs_update = () => {
    let request = $.get('https://' + window.location.host + `/widget/cofs_api.php?all_express_bets`, function (data) {
        //console.log(data); 
        if (data?.response?.cofs) {
            let new_cofs = data.response.cofs;
            $('.card-bet__item[data-tournament_id]').each(function () {
                try {
                    let $cofblock = $(this);
                    let tournament_id = $cofblock.data('tournament_id');
                    let bet_type = $cofblock.find('[data-bet_type]').data('bet_type');

                    let $team1_cofblock = $cofblock.find('[data-team="team_1"][data-cof][data-p_coff]');
                    let team1_oldcof = $cofblock.find('[data-team="team_1"][data-cof]').data('cof');
                    $team1_cofblock.find('.cof_direction svg').hide();

                    let $team2_cofblock = $cofblock.find('[data-team="team_2"][data-cof][data-p_coff]');
                    let team2_oldcof = $cofblock.find('[data-team="team_2"][data-cof]').data('cof');
                    $team2_cofblock.find('.cof_direction svg').hide();

                    let cof = new_cofs.find(c => c.tournament_id == tournament_id && c.type == bet_type && c.time_from_update < c.time_close_live);
                    if (cof) {

                        if (cof.team_1_cof) {
                            //$team1_cofblock.removeClass('disabled');
                            $team1_cofblock.data('p_coff', cof.team_1_rate).data('cof', cof.team_1_cof);
                            $team1_cofblock.find('.js_cof').text(formatCof(cof.team_1_cof));
                            $team1_cofblock.find('.js_rate').text(`${cof.team_1_rate}%`);

                            if (cof.team_1_cof > team1_oldcof) {
                                $team1_cofblock.find('.js_arrows_up_icon').show();
                            } else if (cof.team_1_cof < team1_oldcof) {
                                $team1_cofblock.find('.js_arrows_down_icon').show();
                            }
                        } else {
                            //$team1_cofblock.addClass('disabled');
                            $team1_cofblock.find('.js_lock_icon').show();
                        }
                        if ($team1_cofblock.find(`span .icon:visible`).length == 0) {
                            $team1_cofblock.find('.js_dash_icon').show();
                        }


                        if (cof.team_2_cof) {
                            //$team2_cofblock.removeClass('disabled');
                            $team2_cofblock.data('p_coff', cof.team_2_rate).data('cof', cof.team_2_cof);
                            $team2_cofblock.find('.js_cof').text(formatCof(cof.team_2_cof));
                            $team2_cofblock.find('.js_rate').text(`${cof.team_2_rate}%`);

                            if (cof.team_2_cof > team2_oldcof) {
                                $team2_cofblock.find('.js_arrows_up_icon').show();
                            } else if (cof.team_2_cof < team2_oldcof) {
                                $team2_cofblock.find('.js_arrows_down_icon').show();
                            }
                        } else {
                            //$team2_cofblock.addClass('disabled');
                            $team2_cofblock.find('.js_lock_icon').show();
                        }
                        if ($team2_cofblock.find(`span .icon:visible`).length == 0) {
                            $team2_cofblock.find('.js_dash_icon').show();
                        }

        
                    } else {
                        $team1_cofblock.find('span .icon').hide();
                        //$team1_cofblock.addClass('disabled');
                        $team1_cofblock.find('.js_lock_icon').show();
                        $team2_cofblock.find('span .icon').hide();
                        //$team2_cofblock.addClass('disabled');
                        $team2_cofblock.find('.js_lock_icon').show();
                    }

                } catch (error) {
                    console.log(error)
                }

            });
            //апдейт блока ставки
            $('.games.bet').each(function () {
                try {
                    let $matchblock = $(this);
                    let tournament_id = $matchblock.data('tournament_id');
                    let bet_type = $matchblock.data('bet_type');
                    let team = $matchblock.data('team');
                    let cof_object = new_cofs.find(c => c.tournament_id == tournament_id && c.type == bet_type && c.time_from_update < c.time_close_live);
                    if (cof_object) {
                        let cof = cof_object[`${team}_cof`];
                        let old_cof = $matchblock.find('[data-cof_express]').data('cof_express');
                        $matchblock.find('input').val(formatCof(cof));
                        $matchblock.find('[data-cof_express]').data('cof_express', cof).find('.js_cof').text(formatCof(cof));

                        $matchblock.find('.js_lock_icon').hide();
                        $matchblock.find('.js_arrows_down_icon').hide();
                        $matchblock.find('.js_arrows_up_icon').hide();
                        //добавить иконку направления кофа
                        if (cof > old_cof) {
                            $matchblock.find('.js_arrows_up_icon').show();
                        } else if (cof < old_cof) {
                            $matchblock.find('.js_arrows_down_icon').show();
                        }
                    } else {
                        //не нашли коф, значит он неактуален
                        $matchblock.find('.js_arrows_down_icon').hide();
                        $matchblock.find('.js_arrows_up_icon').hide();
                        $matchblock.find('.js_lock_icon').show();
                    }
                } catch (error) {
                    console.log(error)
                }
            });


            $('.input-range').change();
            $('body').trigger('update:totalandprofit');
        }
    })
        .fail(function (jqXHR, textStatus, error) {
            console.error(error);
            $('.js_arrows_down_icon').hide();
            $('.js_arrows_up_icon').hide();
        })
}
